<template>
  <div>
    <div class="clearfix form-group has-search tw-flex tw-flex-col">
      <div class="col-md-6 tw-mt-8 tw-relative">
          <span class="fa fa-search form-control-feedback fa fa-search form-control-feedback tw--translate-y-1/2 tw-absolute tw-top-1/2 tw-left-[12px] tw-pt-0"></span>
          <input
            type="text"
            class="tw-rounded-2xl form-control"
            ref="patientsearch"
            placeholder="Procure pelo nome ou CPF do paciente"
            v-model="query"
            autofocus
          />
          <img v-bind:src="railsImage" v-if="loading" class="tw-absolute tw-right-3 tw-top-1/2 tw--translate-y-1/2" >
      </div>
      <div v-if="/\d/.test(query)" class="tw-ml-4 tw-mt-2 tw-text-gray-600">
        Para buscar pelo CPF utilize o formato com pontos. Exemplo: 123.456.296-12
      </div>
    </div>
    <div class="patients">
      <table class="table result">
        <thead v-if="patients.length != 0">
          <tr>
            <th>Nome</th>
            <th>Telefone</th>
            <th>CPF</th>
          </tr>
        </thead>
        <tbody v-if="!loaded">
          <tr>
            <td colspan="3">
              <content-loader width="300" height="20" primaryColor="#f3f3f3" secondaryColor="#cccccc">
                <rect x="20" y="5" rx="3" ry="3" width="70%" height="4" />
                <rect x="20" y="13" rx="3" ry="3" width="30%" height="4" />
                <circle cx="10" cy="10" r="6" />
              </content-loader>
            </td>
          </tr>
          <tr>
            <td colspan="3">
              <content-loader width="300" height="20" primaryColor="#f3f3f3" secondaryColor="#cccccc">
                <rect x="20" y="5" rx="3" ry="3" width="70%" height="4" />
                <rect x="20" y="13" rx="3" ry="3" width="30%" height="4" />
                <circle cx="10" cy="10" r="6" />
              </content-loader>
            </td>
          </tr>
          <tr>
            <td colspan="3">
              <content-loader width="300" height="20" primaryColor="#f3f3f3" secondaryColor="#cccccc">
                <rect x="20" y="5" rx="3" ry="3" width="70%" height="4" />
                <rect x="20" y="13" rx="3" ry="3" width="30%" height="4" />
                <circle cx="10" cy="10" r="6" />
              </content-loader>
            </td>
          </tr>
        </tbody>
        <tbody v-if ="(loaded && query) && patients.length == 0">
          <tr>
            <td colspan="3">
              <img v-bind:src="noResultsImg" class="empty-state__image  tw-mt-4 tw-mb-2 tw-w-60 empty-state__image--big" />
              <h3 class="empty-state__title tw-w-full tw-z-10 tw-text-gray-800 tw-my-2">
                Ops! Não foi possível encontrar o paciente com os termos "{{ query }}"
              </h3>
              <p class="empty-state__description tw-mb-14">
                Tente novamente usando termos diferentes
              </p>
            </td>
          </tr>
        </tbody>

        <tbody v-else>
          <tr v-if="loaded && patients.length == 0">
            <td colspan="3">
              <div class="tw-text-center tw-mb-12" v-if="accessAllPatients">
               <img v-bind:src="noPatientImg" class="empty-state__image empty-state__image--big"/>
               <h3 class="empty-state__title  tw-w-full tw-block tw-mt-2 tw-relative tw-z-10">Você não tem nenhum paciente cadastrado</h3>
                <p class="empty-state__description tw-w-full tw-mt-2 tw-block  tw-relative tw-z-10">
                  Pegue uma xícara de café e vamos começar!
                </p>
              </div>
            </td>
          </tr>

          <tr v-else v-for="patient in patients">
            <td>
              <a :href="`/patients/${patient.id}`" class="tw-text-blue-600 tw-flex">
                <img
                  class="patients-photo-image tw-inline tw-float-left tw-shrink-0"
                  v-if="patient.photo"
                  :src="patient.photo"
                />

                <div v-else class="patient-initial tw-shrink-0">{{ patient.fullName[0] }}</div>

                <div :class="['tw-flex', 'tw-flex-col', patient.last_appointment ? 'tw-justify-between' : 'tw-justify-center']">
                  <span class="tw-font-semibold tw-text-base">{{ patient.fullName }}</span>

                  <span v-if="!!patient.cellphone && canEditPatient" class="md:tw-hidden tw-leading-none tw-text-gray-600 tw-text-xs tw-mt-3">
                    Telefone: {{ patient.cellphone }}
                  </span>
                  <span v-if="!!patient.cpf && canEditPatient" class="md:tw-hidden tw-leading-none tw-text-gray-600 tw-text-xs tw-mt-3">
                    CPF: {{ patient.cpf }}
                  </span>

                  <span v-if="patient.last_appointment" class="tw-text-xs tw-text-gray-600 tw-mt-3 md:tw-mt-0">
                    {{ patient.last_appointment_with_time >= new Date() ? `Última consulta agendada: ${patient.last_appointment} - em ${patient.time_ago}` : `Última consulta agendada: ${patient.last_appointment} - ${patient.time_ago} atrás` }}
                  </span>
                </div>
              </a>
            </td>
            <td>
              {{ canEditPatient ? patient.cellphone : "" }}
              <a v-if="patient.cellphone && canEditPatient" title="Abrir WhatsApp" class="tw-inline-block tw-ml-2" :href="'https://wa.me/55'+patient.cellphone.replace(/\D/g, '')" onclick="mixpanel.track('Click WhatsApp Icon - Patient list')" target="_blank"><svg style="fill: rgb(181 189 201)" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"><path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z"></path></svg></a>
            </td>
            <td>{{ canEditPatient ? patient.cpf : "" }}</td>
          </tr>

        </tbody>
      </table>
      <div class="search-footer">
        <div v-if="accessAllPatients">
          <div
            class="patient-footer-show-result"
          >Mostrando {{ patients.length }} de {{ patientsCount }} resultados</div>
          <div class="patient-footer-pages" v-if="patientsRemaining > 0">
            <a
              @click.prevent="fetchMore"
              class="tw-text-blue-600"
            >Mostrar {{ patientsRemaining > 50 ? 50 : patientsRemaining }} mais</a>
          </div>
        </div>
        <div v-if="downloadPatients">
          Baixar lista completa:
          <div v-if="!exportLinksDisabled" class="tw-inline-block">
            <a
              href="/patients.xlsx"
              @click="temporarilyDisableExportLink"
              class="tw-text-blue-600"
            >Excel</a> |
            <a
              href="/patients.csv"
              @click="temporarilyDisableExportLink"
              class="tw-text-blue-600"
            >CSV</a>
          </div>
          <span v-else>Gerando lista...</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { formatDistanceToNow } from "date-fns";
import ptBR from "date-fns/locale/pt-BR";
import noPatientImg from 'images/illustrations/no-patient-registered.png';
import railsImage from 'images/spinner.svg';
import noResultsImg from 'images/illustrations/no-results-patient.png';
import { ContentLoader } from "vue-content-loader";

export default {
  props: {
    downloadPatients: Boolean,
    accessAllPatients: Boolean,
    canEditPatient: Boolean,
    initialPatients: Array,
    initialPatientsCount: Number,
  },
  components: {
    ContentLoader,
  },
  data() {
    return {
      railsImage,
      noPatientImg,
      noResultsImg,
      patients: this.calculateTimeAgo(this.initialPatients),
      query: "",
      patientsCount: this.initialPatientsCount,
      page: 1,
      loaded: this.initialPatients.length > 0,
      exportLinksDisabled: false,
      loading: false
    };
  },
  mounted() {
    const url = new URL(window.location.href);
    this.query = url.searchParams.get('query');
    this.query = this.query ? this.query : ""
    if (this.patients.length == 0) {
      this.fetch();
    }
    this.$refs.patientsearch.focus();
  },
  computed: {
    patientsRemaining() {
      return this.patientsCount - this.patients.length;
    }
  },
  watch: {
    query() {
      if (this.query.length > 0 && this.query.length < 2) {
        return;
      }
      this.updateUrl()
      this.loading = true;
      this.fetch();
    }
  },
  methods: {
    updateUrl() {
      const url = new URL(window.location.href);
      url.searchParams.set('query', this.query);
      Turbolinks
        .controller
        .pushHistoryWithLocationAndRestorationIdentifier(url.href, Turbolinks.uuid())
    },
    fetch: _.debounce(function(e) {
      axios.get(`/patients/search`, { params: { query: this.query } })
      .then(response => {
        this.loading = false;
        this.page = 1;
        this.patients = this.calculateTimeAgo(response.data);
        this.patientsCount = Number(response.headers['x-patient-count']);
        this.loaded = true;
      }).catch(() => {
        this.loading = false;
      }) ;
    }, 500),
    fetchMore() {
      this.loading = true;
      axios
        .get(`/patients/search`, { params: { query: this.query, page:  this.page + 1} })
        .then(response => {
          this.loading = false
          this.patients = this.patients.concat(this.calculateTimeAgo(response.data));
          this.patientsCount = Number(response.headers['x-patient-count']);
          this.page = this.page + 1;
        }).catch(() => {
        this.loading = false;
      });
    },
    calculateTimeAgo(patients){
      return patients.map(patient => {
          if (!patient.last_appointment){
            return patient;
          }

          const date = new Date(patient.last_appointment_with_time);
          patient.last_appointment_with_time = date;
          patient.time_ago = formatDistanceToNow(date, {
            locale: ptBR,
            includeSeconds: true
          }).replace("cerca de", "aproximadamente")

          return patient
        })
    },
    temporarilyDisableExportLink() {
      this.exportLinksDisabled = true;
      setTimeout(() => {
        this.exportLinksDisabled = false;
      }, 2000);
    }
  }
};
</script>
